export default {
  title: 'Tablette de fidélité',
  headers: {
    customer_frequency: 'Fréquence client',
  },
};
